import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: true
})
export class AlertComponent {
  @Input() public title: string = '';
  @Input() public message: string = '';
  @Input() public continueText: string = '';
  @Input() public cancelText: string = '';

  @Output() public continueEvent: EventEmitter<void> = new EventEmitter();
  @Output() public cancelEvent: EventEmitter<void> = new EventEmitter();

  // Emits an event when user chooses to continue
  public continue(): void {
    this.continueEvent.emit();
  }

  // Emits an event when user cancels the alert
  public cancel(): void {
    this.cancelEvent.emit();
  }
}
